module.exports = {
  platform: 'voice',
  name: 'Log',
  node: 'log',
  bg: '#FFFFFF',
  note: '',
  property: {
    message: '',
    log_level: 'info',
    send_notification: false,
    api: {
      methods: 'GET',
      url: '',
      headers: [{ key: 'content-type', value: 'application/json' }],
      body: '',
      setting: {
        timeout: '30.0',
        await: false
      }
    }
  }
}
